<template>
  <div class="productList">
    <div class="content">
      <div class="listGroup mobile-hide">
        <ul
          class="list"
          v-for="(item,index) in allGroups"
          key="index"
          v-if="item.ProductGroup_id === 19"
        >
          <li @click="$router.push({path:'/collections/Wholesale'})">
            <span>{{ $t('wholesale') }}</span>
          </li>
          <li
            v-for="(cat,index) in item.Categories"
            key="index"
            @click="navGo(cat)"
          >
            <span v-if="$i18n.locale=='en'">{{cat.Name}}</span>
            <span v-if="$i18n.locale=='ch'">{{cat.Description}}</span>
          </li>
        </ul>
      </div>
      <!-- banner -->
      <div class="banner">
        <swiper :options="bannerSwiper">
          <!-- slides -->
          <swiper-slide v-for="(item,index) in filterBillboard(this.$store.state.billboard.billboardImages, $i18n.locale)" data-index="index" :key="index">
            <div v-if="item.URL">
              <a :href="item.URL"><img class='banner-img' :src='item.Image'/></a>
            </div>
            <div v-else ><img class='banner-img' :src='item.Image'/></div>
          </swiper-slide>
          <div class="swiper-pagination"  slot="pagination"></div>  
        </swiper>
      </div>
      <!-- end banner -->
      <div class="selectCrumb">
        <breadcrumb v-if='$i18n.locale=="en"' v-bind:path2="this.group"></breadcrumb>
        <breadcrumb v-if='$i18n.locale=="ch"' v-bind:path2="this.chgroup"></breadcrumb>
        <!--select order-->
        <div class="collection-header">
          <div class="filters-toolbar-wrapper">
            <div class="filters-toolbar__item-child">
              <p>{{ $t('sortBy') }} :</p>
              <el-select
                v-model="sortOption"
                v-bind:placeholder="$t('pleaseSelectSortingMethod')"
                value=""
                @change="updateSort"
              >
                <el-option
                  v-for="item in sortOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!--end select order-->
      </div>
    
      <!-- container -->
      <div class="product-listing-container">

        <!-- left group & category -->
        <div class="product-list-left">
          <div class="group">
            <span v-if='$i18n.locale=="en"'>{{this.group}}</span>
            <span v-if='$i18n.locale=="ch"'>{{this.chgroup}}</span>
          </div>
          <div class="category">
            <ul>
              <li
                v-for="(item,index) in categoryList"
                :label="item.Name"
                :value="item"
                @click="fetchSelectedCategories(item)"
              >
                <span v-if="$i18n.locale=='en'">{{item.Name}}</span>
                <span v-if="$i18n.locale=='ch'">{{item.Description}}</span>
              </li>
            </ul>
          </div>
        </div>
        <!-- end left group & category -->

        <!-- product list -->
        <div v-if="this.isLoadings" class="product-list-right">
          <div class="loadmore disableBtn">
            <span>{{ $t('loadingProducts')}}</span>
            <i class="loading">
              <div class="loading-bar"></div>
              <div class="loading-bar"></div>
              <div class="loading-bar"></div>
              <div class="loading-bar"></div>
            </i>
          </div>
        </div>
        <div v-if="!this.isLoadings" class="product-list-right">
          <div class="title">
            <div>
              <span v-if='$i18n.locale=="en"'>{{this.group}}</span>
              <span v-if='$i18n.locale=="ch"'>{{this.chgroup}}</span>
              <span v-if='$i18n.locale=="en" && selectedCategory.Name!==""'> > {{this.selectedCategory.Name}}</span>
              <span v-if='$i18n.locale=="ch" && selectedCategory.Description!=="" '> > {{this.selectedCategory.Description}}</span>
            </div>
            <div class="numberPick">
              <el-select v-model="numberOption" placeholder="#" value="" @change="updateNumber">
                <el-option
                  v-for="item in numberOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <ul>
            <li v-for="(item, index) in filterList" v-bind:key="index" v-if="!item.IsStopSale">
              <productCard
                v-if='$i18n.locale=="en"'
                v-bind:img="item.ThumbnailLarge"
                v-bind:link="item.link"
                v-bind:name="item.Name"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:inCart="inCart"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
                v-bind:group="item.group"
                v-bind:endTime="item.EndTime"
                v-bind:GroupedSaleLimit="item.GroupedSaleLimit"
                v-bind:GroupSoldQuantity="item.GroupSoldQuantity"
              ></productCard>
              <productCard
                v-if='$i18n.locale=="ch"'
                v-bind:img="item.ThumbnailLarge"
                v-bind:link="item.link"
                v-bind:name="item.Description"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:inCart="inCart"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
                v-bind:group="item.group"
                v-bind:endTime="item.EndTime"
                v-bind:GroupedSaleLimit="item.GroupedSaleLimit"
                v-bind:GroupSoldQuantity="item.GroupSoldQuantity"
              ></productCard>
            </li>
          </ul>
          <pagination
            :totalPages="pages"
            :total="counts"
            :currentPage="currentPage"
            @pagechanged="onPageChange"
          />
        </div>
      </div>
      <!-- end product list -->
    </div>
    <!-- end container -->
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "@/components/breadcrumb";
import pagination from "@/components/pagination";
import productCard from "./productCard";
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart,
  flyToElement
} from "../store/modules/cart";
export default {
  name: "productList",
  components: {
    breadcrumb,
    pagination,
    productCard,
  },
  props: {
    isLoading: { type: Boolean },
    group: {
      type: String,
    },
    // chgroup: {
    //   type: String,
    // }
  },
  data() {
    return {
      chgroup: '',
      categoryList: [],
      selectedCategory: {
        Name: '',
        Description: '',
      },
      // banner
      bannerSwiper: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination'
        },
        simulateTouch: false,
        navigation: {
          nextEl: '.banner-button-next',
          prevEl: '.banner-button-prev',
        },
      },
      // number option
      numberOption: '', // number per page
      numberOptions: [
        { value: 15, label: '15' },
        { value: 30, label: '30' },
        { value: 60, label: '60' }
      ],
      currentPage: 1,
      pages: 1,
      counts: 0,
      // sort option
      sortOption:"",
      isLoadings:this.isLoading,
      // drop down
      sortOptions: [{
        value: '1',
        label: 'Alphabetically, A-Z'
      }, {
        value: '2',
        label: 'Alphabetically, Z-A'
      }, {
        value: '3',
        label: 'Price, low to high'
      }],
      
      filterList: [],
      list: [],
      listReg: [],
      listOut: [],
      catReg: [],
      catOut: [],
      inCart: null,
    }
  },
  methods: {
    ...mapActions('products',['fetchCategories', 'fetchProductsWithGroupId', 'fetchGroupBuyWithId', 'fetchWholesaleWithId']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    filterBillboard(billboard, language) {
      const filterBillboard = billboard.filter(image => {
        return image.Language.toLowerCase() === language;
      });
      return filterBillboard;
    },
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true
    },
    sortCategoryList(list) {
      list = list.sort((a,b) => {
        return a.Name[0] > b.Name[0] ? 1 : -1;
      })
    },
    updateSort(value) {
      this.sortOption = value;
      this.updateFilter();
    },
    updateNumber(value) {
      this.numberOption = value;
      this.updateFilter();
    },
    updateFilter() {
      this.filterList = this.list;
      
      if (this.sortOption === '1') {
        this.filterList = this.filterList.sort((a,b) => {
          return a.Name[0] > b.Name[0] ? 1 : -1;
        })
      }
      if (this.sortOption === '2') {
        this.filterList = this.filterList.sort((a,b) => {
          return a.Name[0] < b.Name[0] ? 1 : -1;
        })
      }
      if (this.sortOption === '3') {
        this.filterList = this.filterList.sort((a,b) => {
          return a.Price - b.Price;
        })
      }
      
      if (this.numberOption > 0) {
        this.counts = this.list.length;
        this.pages = Math.ceil(this.list.length / this.numberOption);
        
        const begin = ((this.currentPage - 1) * this.numberOption);
        const end = begin + this.numberOption;
        this.filterList = this.list.slice(begin, end);
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.updateFilter();
      window.scrollTo(0, 0);
    },
    fetchSelectedCategories(item) {
      this.fetchCategories(item.ProductCategory_id)
      .then(res => {
        const ctemp1 = [];
        const ctemp2 = [];
        const sortedData = res.data.map((a)=>{
          if(this.isOutOfStock(a)) {
            ctemp2.push(a)
          } else {
            ctemp1.push(a)
          }
        }) 
        this.catOut = ctemp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        this.catReg = ctemp1.sort((a,b) => {
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        })
        this.list = this.catReg.concat(this.catOut);
        this.selectedCategory['Name']= item.Name;
        this.selectedCategory['Description']= item.Description;
        this.filterList = this.list;
      })
      .catch(err => {
        console.log('err fetching product', err);
      })
    },
    fetchSelectedGroup(id, type) {
      this.isLoadings = true;
      this.fetchProductsWithGroupId([id, type])
      .then(res => {
        this.isLoadings = false;
        const temp1 = [];
        const temp2 = [];
        const sortedData = res.data.map((a)=>{
          if(this.isOutOfStock(a)) {
            temp2.push(a)
          }else {
            temp1.push(a)
          }
        }) 
        this.listOut = temp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        this.listReg = temp1.sort((a,b) => {
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        })

        this.list = this.listReg.concat(this.listOut);
        this.filterList = this.list;
        
        if (this.numberOption > 0) {
          this.counts = this.list.length;
          this.pages = Math.ceil(this.list.length / this.numberOption);
          
          const begin = ((this.currentPage - 1) * this.numberOption);
          const end = begin + this.numberOption;
          this.filterList = this.list.slice(begin, end);
        }
        
        if (this.$route.params.group == 'group'){
          this.list.forEach(item=>{
            item.group = true;
          })
        }
      })
      .catch(err => {
        this.isLoadings = false;
        console.log('err', err)
      })
    },

    fetchGroupBuy(id) {
      this.isLoadings = true;
      this.fetchGroupBuyWithId()
      .then(res => {
        this.isLoadings = false;

        const temp1 = [];
        const sortedData = res.data.record.map((a)=>{
          // temp1.push({ IsOverSaleable: false, IsPromotion: true, });
          temp1.push({...a, group: true, Name: a.ProductName, IsPromotion: true, Product_id: a.Product, Price: a.ProductGroupPrice, OriginalPrice: a.RefPrice});
        })
        this.list = temp1;
        this.filterList = this.list;

        // const temp1 = [];
        // const temp2 = [];
        // const sortedData = res.data.map((a)=>{
        //   if(this.isOutOfStock(a)) {
        //     temp2.push(a)
        //   }else {
        //     temp1.push(a)
        //   }
        // }) 
        // this.listOut = temp2.sort((a,b)=>{
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // });
        // this.listReg = temp1.sort((a,b) => {
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // })
        // this.list = this.listReg.concat(this.listOut);
        
        // if(this.$route.params.group == 'group'){
        //   this.list.forEach(item=>{
        //     item.group = true
        //   })
        // }
       
      })
      .catch(err => {
        this.isLoadings = false;
        console.log('err', err)
      })
    },
    fetchWholesale(id) {
      this.isLoadings = true;
      this.fetchWholesaleWithId()
      .then(res => {
        this.isLoadings = false;
        const temp1 = [];
        const sortedData = res.data.record.map((a)=>{
          // temp1.push({ IsOverSaleable: false, IsPromotion: true, });
          temp1.push({...a, EndTime: null, group: true, Name: a.ProductName, IsPromotion: true, Product_id: a.Product, Price: a.ProductGroupPrice, OriginalPrice: a.RefPrice});
        })
        this.list = temp1;
        this.filterList = this.list;

        // const temp1 = [];
        // const temp2 = [];
        // const sortedData = res.data.map((a)=>{
        //   if(this.isOutOfStock(a)) {
        //     temp2.push(a)
        //   }else {
        //     temp1.push(a)
        //   }
        // }) 
        // this.listOut = temp2.sort((a,b)=>{
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // });
        // this.listReg = temp1.sort((a,b) => {
        //   return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        // })
        // this.list = this.listReg.concat(this.listOut);
        
        // if(this.$route.params.group == 'group'){
        //   this.list.forEach(item=>{
        //     item.group = true
        //   })
        // }
       
      })
      .catch(err => {
        this.isLoadings = false;
        console.log('err', err)
      })
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item);
    },
    handleAddToCartFail() {
      alert('no enought product in stock');
    },
    addToCart: function(item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        .then(() => {
        flyToElement(event.target, $('.cart-link'));
        })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        flyToElement(event.target, $('.cart-link'));
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      // this.$router.push({ name: 'productDetails', params: { productNum: product.ProductNum} })
      this.$router.push({ path: '/productDetails', query: { productNum: product.ProductNum}})
    },
    navGo(category) {
      this.$router.push(`/collections/${category.Name.toLowerCase()}`)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
      .then(() => {
        const cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
        const isUSA = localStorage.getItem('isUSA');
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
        .then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: mapState({
    allGroups: state => state.navbar.allGroups,
    activeCategory: state => state.products.activeCategory,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    necessaryCartItems: state => state.cart.necessaryCartItems,
    itemCount: state => state.cart.itemCount,
    IsShareCreditUsed: (state) => state.checkout.IsShareCreditUsed,
  }),
  watch: {
    allGroups: function(newVal, oldVal) {
      if(this.$route.params.group == 'Group Buy'){
        this.fetchGroupBuy(1)
        return
      }
      if(this.$route.params.group == 'Wholesale'){
        this.fetchWholesale(1)
        return
      }
      // let currentGroupType = '';
      // newVal.forEach(group => {
      //   if(this.group.toLowerCase() === group.Name.toLowerCase()){
      //     currentGroup.push(group);
      //     currentGroupType = 'group';
      //   }
      //   group.Categories.forEach(item=>{
      //     if(item.Name.toLowerCase() === this.group.toLowerCase()){
      //       currentGroup.push(item);
      //       currentGroupType = 'category';
      //     }
      //   })
      // })
      const currentGroup = newVal.filter(group => {
        return group.Name.toLowerCase() === this.group.toLowerCase();
      });
      this.categoryList = currentGroup[0].Categories;

      this.sortCategoryList(this.categoryList);
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id, 'group');
      
      // if (currentGroup.length>0 && currentGroupType === 'category') {
      //   this.chgroup = currentGroup[0].Description;
      //   this.fetchSelectedGroup(currentGroup[0].ProductCategory_id, 'category')
      // }
      //   if (currentGroup.length>0 && currentGroupType === 'group') {
      //   this.chgroup = currentGroup[0].Description;
      //   this.fetchSelectedGroup(currentGroup[0].ProductGroup_id, 'group')
      // }
    },
    group: function(newVal, oldVal) {
      this.selectedCategory['Name']= ''
      this.selectedCategory['Description']= '';
      
      if(this.$route.params.group == 'groupbuy'){
        this.fetchGroupBuy(1)
        return
      }

      const currentGroup = this.allGroups.filter(group => {
        return newVal === group.Name.toLowerCase();
      });

      // this.allGroups.forEach(group => {
      //   group.Categories.forEach(item=>{
      //     if(newVal === item.Name.toLowerCase()){
      //       currentGroup.push(item)
      //     }
      //   })
      // })

      if (currentGroup) {
        this.chgroup = currentGroup[0].Description;
      }
      this.categoryList = [];
      this.categoryList = currentGroup[0].Categories;
      
      // this.option = '';
      // if(this.group.toLowerCase() === 'frozen') {
      //   this.categoryList = currentGroup[0].Categories;
      // }
      
      // fetch produtcts from the first category
      this.fetchSelectedGroup(currentGroup[0].ProductCategory_id, 'group');
    },
    $route(to, from) {
      const currentGroup = []
      let currentGroupType = '';
      if (to.path === "/collections/Group Buy") {
        this.fetchGroupBuy(1)
        return;
      } else if (to.path === "/collections/Wholesale") {
        this.fetchWholesale(1)
        return;
      } else if (to.name === "productList") {
        this.allGroups.forEach(group => {
          if (this.group === group.Name.toLowerCase()){
            currentGroup.push(group);
            currentGroupType = 'group';
          }
          group.Categories.forEach(item=>{
            if(this.group === item.Name.toLowerCase()){
              currentGroup.push(item);
              currentGroupType = 'category';
            }
          })
        })

        if (currentGroup.length>0 && currentGroupType === 'category') {
          this.chgroup = currentGroup[0].Description;
          this.fetchSelectedGroup(currentGroup[0].ProductCategory_id, 'category')
        }
        if (currentGroup.length>0 && currentGroupType === 'group') {
          this.chgroup = currentGroup[0].Description;
          this.fetchSelectedGroup(currentGroup[0].ProductGroup_id, 'group')
        }
      }
    }
  },
  mounted: function() {
    this.$store.dispatch('billboard/fetchBillboardImages');

    if (this.$route.params.group == 'Group Buy'){
      this.chgroup = '团购';
      this.fetchGroupBuy(1)
      return
    } 
     if(this.$route.params.group == 'Wholesale'){
      this.chgroup = '批发';
      this.fetchWholesale(1)
      return
    } 
    
    this.$root.fetchSelectedGroup = this.fetchSelectedGroup.bind(this);

    let currentGroupType = '';
    const currentGroup = [];
    this.allGroups.forEach(group => {
      if(this.group === group.Name.toLowerCase()){
        currentGroup.push(group);
        currentGroupType = 'group';
      }
      group.Categories.forEach(item=>{
        if(this.group === item.Name.toLowerCase()){
          currentGroup.push(item);
          currentGroupType = 'category';
        }
      })
    })
    if (currentGroup.length>0 && currentGroupType === 'category') {
      this.chgroup = currentGroup[0].Description;
      this.fetchSelectedGroup(currentGroup[0].ProductCategory_id, 'category');
    }
    if (currentGroup.length>0 && currentGroupType === 'group') {
      this.chgroup = currentGroup[0].Description;
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id, 'group');
    }
    // this.categoryList = [];
    this.categoryList = currentGroup[0].Categories;
    this.sortCategoryList(this.categoryList);
    if (currentGroup[0]) {
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id);
    }    
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productList.less";
</style>



// WEBPACK FOOTER //
// src/view/productList.vue